/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_UseInputs */

const en_us2_gyms_use = /** @type {(inputs: Gyms_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use this one`)
};

const pt_br2_gyms_use = /** @type {(inputs: Gyms_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar esta`)
};

const es_419_gyms_use = /** @type {(inputs: Gyms_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar este`)
};

const pt_pt2_gyms_use = /** @type {(inputs: Gyms_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar este`)
};

const fr_fr2_gyms_use = /** @type {(inputs: Gyms_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliser`)
};

const de_de2_gyms_use = /** @type {(inputs: Gyms_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses nutzen`)
};

const it_it2_gyms_use = /** @type {(inputs: Gyms_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa questa`)
};

/**
* | output |
* | --- |
* | "Use this one" |
*
* @param {Gyms_UseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_use = /** @type {((inputs?: Gyms_UseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_UseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_use(inputs)
	if (locale === "es-419") return es_419_gyms_use(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_use(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_use(inputs)
	if (locale === "de-DE") return de_de2_gyms_use(inputs)
	if (locale === "it-IT") return it_it2_gyms_use(inputs)
	return en_us2_gyms_use(inputs)
});
export { gyms_use as "gyms.use" }